  // Get references to the anchor tag, the menu, and the "ugly-header" element
  const anchorTag = document.getElementById("HeaderMenu-shop");
  const menu = document.getElementById("shop-nav");
  const uglyHeader = document.getElementById("ugly-header");

  // Function to show the menu on hover and add class to both "ugly-header" and "anchorTag"
  function showMenu() {
    menu.style.display = "block";
    menu.style.height = "auto"; // Set the height to 'auto' to accommodate content
    menu.style.opacity = "1"; // Set opacity to fully visible (1)
    uglyHeader.classList.add("open-menu"); // Add the class to "ugly-header"
    anchorTag.classList.add("menu-open"); // Add the class to "anchorTag"
  }

  // Function to hide the menu when the mouse leaves both the anchor tag and the menu and remove class from both "ugly-header" and "anchorTag"
  function hideMenu(event) {
    const relatedTarget = event.relatedTarget || event.toElement;
    if (!menu.contains(relatedTarget) && !anchorTag.contains(relatedTarget)) {
      menu.style.height = "0";
      menu.style.opacity = "0"; // Set opacity to fully transparent (0)
      setTimeout(() => {
        menu.style.display = "none";
        uglyHeader.classList.remove("open-menu"); // Remove the class from "ugly-header"
        anchorTag.classList.remove("menu-open"); // Remove the class from "anchorTag"
      }, 300); // Set the timeout to match the CSS transition duration
    }
  }

  // Add event listeners to the anchor tag and the menu
  anchorTag.addEventListener("mouseover", showMenu);
  anchorTag.addEventListener("mouseout", hideMenu);
  menu.addEventListener("mouseout", hideMenu);

// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Find the element with the id "HeaderMenu-shop-mobile"
  var shopMobileLink = document.getElementById("HeaderMenu-shop-mobile");
  var shopNav = document.getElementById("shop-nav");
  var closeNavButton = document.getElementById("close-nav");

          // Get all list items
        var listItems = document.querySelectorAll("li");

        // Loop through list items and check for sub-menu
        listItems.forEach(function(item) {
            var subMenu = item.querySelector("ul.sub-menu");
            if (subMenu) {
                item.classList.add("has-sub-menu");
            }
        });

  
  // Check if the element exists
  if (shopMobileLink) {
    // Find the <span> element inside the link
    var spanElement = shopMobileLink.querySelector("span");

    // Change the text inside the <span> element to "Shop"
    if (spanElement) {
      spanElement.textContent = "Shop";
    }
  }

  // Check if both elements exist
  if (shopMobileLink && shopNav && closeNavButton) {
    // Add a click event listener to #HeaderMenu-shop-mobile
    shopMobileLink.addEventListener("click", function (event) {
      // Prevent the default link behavior (e.g., following the href)
      event.preventDefault();

      // Add the .open-nav class to #shop-nav
      shopNav.classList.add("open-nav");
    });

    // Add a click event listener to #close-nav button
    closeNavButton.addEventListener("click", function (event) {
      // Prevent the default button behavior (e.g., form submission)
      event.preventDefault();

      // Remove the .open-nav class from #shop-nav
      shopNav.classList.remove("open-nav");
    });
  }
});


// Get all elements with the class 'sub-menu-dropdown'
const dropdowns = document.querySelectorAll('.sub-menu-dropdown');

// Add a click event listener to each 'sub-menu-dropdown' element
dropdowns.forEach(dropdown => {
  dropdown.addEventListener('click', function() {
    // Find the closest parent 'has-sub-menu' element
    const parentMenuItem = this.closest('.has-sub-menu');

    // Find the 'sub-menu' element inside the parent 'has-sub-menu'
    const subMenu = parentMenuItem.querySelector('.sub-menu');

    // Toggle the 'show' class on the 'sub-menu' element
    subMenu.classList.toggle('show');
  });
});
